"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
var StyledWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n\n  label: Select__Wrapper;\n"], ["\n  position: relative;\n\n  label: Select__Wrapper;\n"])));
var StyledSelect = styled_1.default.select(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  padding-right: 30px;\n  &::-ms-expand {\n    display: none;\n  }\n\n  label: Select;\n"], ["\n  ", "\n  padding-right: 30px;\n  &::-ms-expand {\n    display: none;\n  }\n\n  label: Select;\n"])), function (_a) {
    var error = _a.error;
    return (0, styles_1.MixinInputBaseStyle)({ error: error });
});
var StyledIcon = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  color: ", ";\n  border-right: 2px solid;\n  border-bottom: 2px solid;\n  width: 10px;\n  height: 10px;\n  transform: translateY(-50%) rotate(45deg);\n  top: calc(50% - 3px);\n  right: 15px;\n  pointer-events: none;\n\n  label: Select__Icon;\n"], ["\n  position: absolute;\n  color: ", ";\n  border-right: 2px solid;\n  border-bottom: 2px solid;\n  width: 10px;\n  height: 10px;\n  transform: translateY(-50%) rotate(45deg);\n  top: calc(50% - 3px);\n  right: 15px;\n  pointer-events: none;\n\n  label: Select__Icon;\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled && styles_1.COLOR.font.disabledIcon) || styles_1.COLOR.font.base;
});
var Select = function (props) {
    return (react_1.default.createElement(StyledWrapper, null,
        react_1.default.createElement(StyledSelect, __assign({}, props), props.children),
        react_1.default.createElement(StyledIcon, { disabled: props.disabled })));
};
exports.Select = Select;
var templateObject_1, templateObject_2, templateObject_3;
